// src/locales/en/footer.js
export const footer = {
    madeWithLove: "ශ්‍රී ලංකාවේ ව්‍යාපාර සඳහා ❤️ සමඟ සාදන ලදී",
    helpCenter: "උපකාර මධ්‍යස්ථානය",
    privacyPolicy: "පෞද්ගලිකත්ව ප්‍රතිපත්තිය",
    termsOfService: "සේවා කොන්දේසි",
    documentation: "ප්‍රලේඛනය",
    copyright: "© {{year}} Rettzy"
}